module.exports = __webpack_public_path__ + "img/about.057f773c.svg";